import React, { useState } from "react";
import "./StudyInAmerica.css";
import FAQ from "./FAQ";
// import FlagCampusImg from "../assets/Careers-headphone.png";
import RegisterWebinar from '../components/WebinarForm'

export default function StudyInAmerica() {
const faqData = [
  {
    question: '1. Which Spoken English level should I join – Beginner, Intermediate, or Advanced?',
    answer: <>
    <ul>
      <li><b>Beginner:</b> This level is for learners who are comfortable with reading and writing in English but face challenges when speaking, even with short sentences of 4 to 5 words. The program builds a strong foundation in basic communication skills, pronunciation, and everyday vocabulary, helping participants gain the confidence to start speaking English naturally in real-life situations.</li>
      <li><b>Intermediate:</b> This level is designed for learners who can form simple sentences but struggle to speak fluently for more than a minute. The program focuses on developing greater confidence, fluency, and clarity, enabling participants to communicate more effectively and carry out their professional responsibilities with ease.</li>
      <li><b>	Advanced:</b> This program is tailored for professionals who already speak English with confidence but seek to enhance their language skills to meet the demands of their careers. It is ideal for teachers, trainers, executives, lawyers, doctors, hospitality professionals, and others whose roles require advanced communication. The focus is on refined pronunciation, enriched vocabulary, effective global customer engagement, professional communication across all levels of corporate hierarchy, and confident participation in meetings, presentations, and official interactions.</li>
      <li><b>TOEFL/IELTS Preparation:</b> This program is tailored for professionals who already speak English with confidence but seek to enhance their language skills to meet the demands of their careers. It is ideal for teachers, trainers, executives, lawyers, doctors, hospitality professionals, and others whose roles require advanced communication. The focus is on refined pronunciation, enriched vocabulary, effective global customer engagement, professional communication across all levels of corporate hierarchy, and confident participation in meetings, presentations, and official interactions.</li>
    </ul>
    </>
  },
  {
    question: '2. How long are the courses?',
    answer: <>
    Each level runs for 3–6 weeks depending on the course.
    <ul>
      <li>Beginner – 3 weeks</li>
<li>Intermediate – 6 weeks</li>
<li>	Advanced – customized for the group – can be anything between 4 weeks to 8 weeks
</li>
    </ul>
    
    </>
  },
  {
    question: '3. Can I skip Beginner and start directly with Intermediate or Advanced?',
    answer: 'Yes! We conduct a free level assessment test before you join, so you’ll be placed in the right level based on your current skills.'
  },
  {
    question: '4. What is the teaching method used in your classes?',
    answer:  <>Our training is practical and interactive. Instead of memorizing grammar. We focus on: <ul>
      <li>Real-life conversations</li>
<li>Vocabulary building exercises</li>
<li>Pronunciation practice
</li>
<li>Confidence-building exercises: 1- or 2-minute speech, impromptu speech, story building, etc</li>
    </ul></>
  },
  {
    question: '5. Do you provide study materials?',
    answer: 'Yes. Your teacher will coordinate on this.'
  },
  {
    question: '6. What will I learn in each level?',
    answer: <>  <ul>
      <li><b>Beginner:</b> Basic grammar, everyday vocabulary, self-introduction, asking/answering questions.</li>
      <li><b>Intermediate:</b> Storytelling, polite conversation, workplace English, correcting common mistakes.</li>
      <li><b>	Advanced:</b> Public speaking, debates, professional writing & presentation skills, accent refinement.</li>
      <li><b>TOEFL/IELTS Preparation:</b> This program is designed for students and professionals aiming to excel in international English proficiency exams. It focuses on all four modules—Listening, Reading, Writing, and Speaking</li>
    </ul></>
  },
  {
    question: '7. Will I become fluent after completing the course?',
    answer: 'Fluency depends on practice outside class too. We give you the tools, strategies, and daily speaking practice to improve rapidly. Students who practice regularly notice big changes within weeks.'
  },
  {
    question: '8. Do you offer both online and offline classes?',
    answer: 'No.  We offer only online classes'
  },
    {
    question: '9. What is the batch size?',
    answer: 'We keep our batches small, maximum 20 students per batch, so that everyone gets personal attention and speaking time.'
  },
    {
    question: '10. How do I enroll?',
    answer: <>Register on our website www.newzealacademy.com You may call/whatsapp +91 63607 05213 if you have any questions, 
    our team will guide you to the right level and schedule. <br/><br/> <a href="/enroll-for-course" className="join-btn" style={{textDecoration: "none"}}>Enroll Now</a> </>
  }
];

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    profession: "",
    course: "",
    phone: "",
    email: "",
    message: ""
  });
 
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
 
  // Update form fields
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
 
  // Submit form to PHP backend
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    // Validate required fields
    if (!formData.firstName || !formData.lastName || !formData.profession || !formData.course || !formData.phone) {
      alert("Please fill all required fields.");
      return;
    }
 
    setLoading(true);
 
    try {
      const response = await fetch("https://newzealacademy.com/RegisterWebinar.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
 
      const result = await response.json();
 
      if (result.status === "success") {
        setSubmitted(true);
        alert("Thank you for enrolling to the Webinar! Please mark the calendar for the webinar.");
      } else {
        alert("Failed to send email. Please try again.");
        console.error(result.message);
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    }
 
    setLoading(false);
  };
 
  const handleCancel = () => {
    window.history.back();
  };
 
  const isFormValid =
    formData.firstName &&
    formData.lastName &&
    formData.profession &&
    formData.course &&
    formData.phone;
  return (
    <div className="siausa-container">
     

      {/* Right Form */}
      <div className="siausa-form-section">
        <h2 className="siausa-form-title">
          Get Registered For<span className="siausa-highlight-pink"> Our Free Webinar Today!</span>
        </h2>
        <p className="siausa-form-subtitle">
          Fill in your details, and our team will reach out to guide you—absolutely free!
        </p>

     <RegisterWebinar/>
      </div>

      <div className="siausa-content">
        <FAQ data={faqData} />
      </div>
    </div>
  );
}
